
document.addEventListener("DOMContentLoaded", function () {
    let footerEmail = document.querySelector('.ctct-form-1099');
    let contactFormEmail = footerEmail.querySelector('.ctct-email');
    let contactFormBtn = footerEmail.querySelector('.ctct-submit');


    function emailValidation(footerEmail, contactFormEmail, contactFormBtn) {

        if (contactFormEmail) {
            contactFormBtn.disabled = true;
            contactFormEmail.addEventListener('input', function (evt) {
                
                footerEmail.classList.add('filled-input');
                var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
                if (testEmail.test(this.value)) {
                    contactFormBtn.disabled = false;
                } else {
                    contactFormBtn.disabled = true;
                };
            });

            document.addEventListener('click', function () {
                if (document.activeElement === contactFormEmail) {
                    footerEmail.classList.add('active-input');
                } else {
                    if (footerEmail.classList.contains('active-input')) {
                        footerEmail.classList.remove('active-input');
                    }
                }
            });
        }
    }
    emailValidation(footerEmail, contactFormEmail, contactFormBtn);
});